import { render, staticRenderFns } from "./GeneratePaymentStudent.vue?vue&type=template&id=66938dc3&"
import script from "./GeneratePaymentStudent.vue?vue&type=script&lang=js&"
export * from "./GeneratePaymentStudent.vue?vue&type=script&lang=js&"
import style0 from "./GeneratePaymentStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports